import createBaseService from "@/api/base-service.ts";
import type { Category } from "../../types/categories";

const lookUptItemService = {
	...createBaseService<Category>("/look-up-items"),
};

export default lookUptItemService;
